import { getContext, setContext, type Component } from 'svelte';

export interface ModalOptions {
	appearance?: 'responsive' | 'fullscreen' | 'dialog' | 'fixed';
	anchor?: 'left' | 'right';
	x?: number;
	y?: number;
	bottom?: number;
}

export interface ModalData<Props extends Record<string, any>> {
	component: Component<Props>;
	props: Props;
	options?: ModalOptions;
}

export class ModalContext {
	/** Modal history is used to navigate between modals.
	 * If the close actions is used while a modal is still
	 * on the history stack, it will navigated to instead
	 * of closing
	 */
	modalHistory: (ModalData<any> & { id: string })[] = $state([]);

	openModal<Props extends Record<string, any>>(
		component: Component<Props>,
		props: Props = {} as Props,
		options: ModalOptions = { appearance: 'responsive', anchor: 'left' }
	) {
		const id = Math.random().toString(16).slice(2);
		this.modalHistory = [{ id, component, props, options }, ...this.modalHistory];
	}

	closeModal() {
		this.modalHistory = this.modalHistory.slice(1);
	}
	closeAllModals() {
		this.modalHistory = [];
	}
}
export const MODAL_CONTEXT_KEY = Symbol('modal');

export function getModalContext() {
	return getContext<ModalContext>(MODAL_CONTEXT_KEY);
}

export function setModalContext(ctx: ModalContext) {
	setContext(MODAL_CONTEXT_KEY, ctx);
}
